import React, { useState, useEffect } from "react";
import "../ProfileAccount/ProfileAccount.css";
import avatarImg from "../../assets/avatar.jpg";
import profilepicture from "../../assets/profileicon.png";
import marketingimg from "../../assets/m2.png";
import myadvertisements from "../../assets/myadvertisements.png";
import addadvertisements from "../../assets/addadvertisements.png";
import accountimg from "../../assets/account-img.png";
import { createPortal } from "react-dom";
import logoutimg from "../../assets/logout-img.png";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRef, useMemo } from "react";
import {
  defaultCountries,
  parseCountry,
  FlagImage,
} from "react-international-phone";
import "react-international-phone/style.css";


export default function ProfileAccount() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [codePhone, setCodePhone] = useState("+966");
  const [phone, setPhone] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(avatarImg);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [city,setCity] = useState("");
const [country,setCountry] =useState("");
const [address,setAddress] =useState("");
const [showLogoutModal, setShowLogoutModal] = useState(false);
const dropdownRef = useRef(null);

const countries = useMemo(
  () => defaultCountries.map(parseCountry),
  []
);

const [isOpen, setIsOpen] = useState(false);
const [selectedIso2, setSelectedIso2] = useState("sa");
  const token = localStorage.getItem("token");

  const navigate = useNavigate();

const handleLogout = () => {
  localStorage.removeItem("token");
  // toast.success("تم تسجيل الخروج 👋");
  navigate("/login");
};
  // ================= GET PROFILE =================
  useEffect(() => {
    const fetchProfile = async () => {
      if (!token) return;

      try {
        const res = await axios.get(
          `${BaseUrl}${BuyerServicesUrl.ShowProfile}`,
          {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
          }
        );

        const data = res.data.data;
        setUsername(data.name || "");
        setEmail(data.email || "");
        setPhone(data.phone || "");
        setCodePhone(data.code_phone || "+966");
        const dialCode = String(data.code_phone || "966");

const matchedCountry = countries.find(
  (c) => c.dialCode === dialCode.replace("+", "")
);

if (matchedCountry) {
  setSelectedIso2(matchedCountry.iso2);
}
        if (data.image) setPreview(data.image);
      } catch (err) {
        console.error(err.response?.data || err);
        toast.error("فشل تحميل بيانات الحساب ❌");
      }
    };

    fetchProfile();
  }, [token]);

  // ================= Handle Image Upload =================
  const handleImageChange = (file) => {
    if (file) {
      if (preview && preview !== avatarImg) {
        URL.revokeObjectURL(preview); 
      }
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    return () => {
      if (preview && preview !== avatarImg) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  // ================= Validate Field =================
  const validateField = (name, value) => {
    switch (name) {
      case "username":
        if (!value.trim()) return "الاسم مطلوب";
        if (value.trim().length < 3) return "يجب أن يكون على الأقل 3 أحرف";
        break;
      case "email":
        if (!value.trim()) return "البريد الإلكتروني مطلوب";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "البريد الإلكتروني غير صالح";
        break;
      case "phone":
        if (!value.trim()) return "رقم الهاتف مطلوب";
        if (!/^\d+$/.test(value)) return "يجب إدخال أرقام فقط";
        if (value.length < 8) return "رقم الهاتف غير صحيح";
        break;
       case "country":
   if (!value.trim()) return "الدولة مطلوبة";
   break;

case "city":
   if (!value.trim()) return "المدينة مطلوبة";
   break;

case "address":
   if (!value.trim()) return "العنوان مطلوب";
   break;
      default:
        return "";
    }
    return "";
  };

  // ================= UPDATE PROFILE =================
  const handleUpdateProfile = async () => {
    if (!token) {
      toast.error("يرجى تسجيل الدخول ❌");
      return;
    }

 const newErrors = {
  username: validateField("username", username),
  email: validateField("email", email),
  phone: validateField("phone", phone),
  country: validateField("country", country),
  city: validateField("city", city),
  address: validateField("address", address),
};
    const hasErrors = Object.values(newErrors).some((err) => err !== "");
    if (hasErrors) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    setLoading(true);

try {
  const formData = new FormData();
  formData.append("name", username);
  formData.append("email", email);
  formData.append("phone", phone);
  formData.append("code_phone", codePhone);
  if (imageFile) formData.append("image", imageFile);

  await axios.post(`${BaseUrl}${BuyerServicesUrl.UpdateProfile}`, formData, {
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  });

  toast.success("تم تحديث البيانات بنجاح ✅");

} catch (err) {
  console.error(err);

  // التعامل مع validation.unique
  if (err.response?.data?.errors) {
    const serverErrors = err.response.data.errors;
    if (serverErrors.email?.includes("validation.unique")) {
      toast.error("البريد الإلكتروني مستخدم مسبقًا ❌");
    }
    if (serverErrors.phone?.includes("validation.unique")) {
      toast.error("رقم الهاتف مستخدم مسبقًا ❌");
    }
  } else {
    toast.error("حدث خطأ أثناء التحديث ❌");
  }
} finally {
  setLoading(false);
}

  };

  return (
    
    <>
     {showLogoutModal &&
      createPortal(
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 9999,
            }}
            onClick={() => setShowLogoutModal(false)}
          />

          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#fff",
              padding: "28px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "400px",
              zIndex: 10000,
              textAlign: "right",
            }}
            dir="rtl"
          >
           {/* <h5 className="mb-3 ">تأكيد تسجيل الخروج</h5> */}
        <h5 className="pt-4 pb-3 fw-bold text-center logout-modalmessage">هل تريد تسجيل الخروج؟</h5>
  {/* <hr className="m-auto"/> */}
        <div className="d-flex justify-content-center gap-2 mt-3 mb-3">
             <button
            className="btn btn-danger px-5 "
            onClick={handleLogout}
          >
            نعم
          </button>
          <button
            className="btn btn-secondary  px-5"
            onClick={() => setShowLogoutModal(false)}
          >
            لا
          </button>
        </div>
          </div>
        </>,
        document.body
      )}
      <div className="profileacc-wrapper container mt-5">
        {/* Sidebar */}
        <div className="m-marketing-sidebar mb-5 col-md-4">
          <Link to="/profileaccount" className="side-btn active white mt-5">
            <img src={profilepicture} alt="" />
            <span className="px-2">حسابي الشخصي</span>
          </Link>

          <Link to="/marketing" className="side-btn white">
            <img src={marketingimg} alt="" />
            <span className="px-2">التسويق</span>
          </Link>
                          {/* <Link to="/bankaccount" className=" side-btn2 text-dark text-decoration-none" style={{width:"98%"}}>
                                     <img className='ps-3' src={accountimg} alt="Bank" style={{ width: "14%",
             marginRight: "2%"}} />
                                                 الحساب البنكي
                                   </Link> */}
          <Link to="/myaddvertisements" className="side-btn white">
            <img src={myadvertisements} alt="" />
            <span className="px-2">إعلاناتي</span>
          </Link>
          <Link to="/addadvertisement" className="side-btn white">
            <img src={addadvertisements} alt="" />
            <span className="px-2">إضافة إعلان</span>
          </Link>
          {/* <Link to="/login" className="side-btn logout">
            <img src={logoutimg} alt="" />
            <span className="px-2">تسجيل الخروج</span>
          </Link> */}
          <button
  type="button"
  className="side-btn logout border-0"
  onClick={() => setShowLogoutModal(true)}
>
  <img src={logoutimg} alt="" />
  <span className="px-2">تسجيل الخروج</span>
</button>
        </div>

        {/* Profile Content */}
        <div className="profile-content col-md-8">
          {/* Avatar */}
          <div className="profile-avatar-wrapper">
            <div className="profileavatar-circle">
              <img src={preview} className="profile-avatar" alt="avatar" />
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={(e) => handleImageChange(e.target.files[0])}
              />
              <button
                type="button"
                className="avatar-edit-btn"
                onClick={() => document.getElementById("fileInput").click()}
              >
                <i className="fa-solid fa-pen"></i>
              </button>
            </div>
          </div>

          {/* Form */}
          <form className="profile-form" onSubmit={(e) => { e.preventDefault(); handleUpdateProfile(); }}>
            <div className="form-group">
              <label className="fw-bolder mb-2">اسم المحل / البائع</label>
              <input
                className="form-input"
                placeholder="ادخل اسم المستخدم"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              {errors.username && <small className="text-danger">{errors.username}</small>}
            </div>

            <div className="form-group">
              <label className="fw-bolder mb-2">البريد الإلكتروني</label>
              <input
                className="form-input"
                placeholder="reem@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </div>

            <div className="form-group">
              <label className="fw-bolder mb-2">رقم الهاتف</label>
              {/* <div className="phone-row">
                <input
                  type="tel"
                  className="phone-number-input"
                  placeholder="123 456 789"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <select
                  className="country-code-input"
                  value={codePhone}
                  onChange={(e) => setCodePhone(e.target.value)}
                >
                  <option value="+966">+966</option>
                  <option value="+20">+20</option>
                  <option value="+971">+971</option>
                  <option value="+962">+962</option>
                  <option value="+974">+974</option>
                </select>
              </div> */}
              <div className="regphone-row">
  <div className="code-dropdown" ref={dropdownRef}>
    <button
      type="button"
      className="code-dropdown-btn"
      onClick={() => setIsOpen((v) => !v)}
    >
      <span className="code-flag">
        <FlagImage iso2={selectedIso2} />
      </span>

      <span className="code-dial">{codePhone}</span>

      <span className="code-arrow">▾</span>
    </button>

    {isOpen && (
      <div className="code-dropdown-menu">
        {countries.map((c) => (
          <button
            type="button"
            key={c.iso2}
            className="code-item"
            onClick={() => {
              setSelectedIso2(c.iso2);
              setCodePhone(`+${c.dialCode}`);
              setIsOpen(false);
            }}
          >
            <span className="code-flag">
              <FlagImage iso2={c.iso2} />
            </span>

            <span className="code-dial">
              +{c.dialCode}
            </span>

            <span className="code-name">
              {c.name}
            </span>
          </button>
        ))}
      </div>
    )}
  </div>

  <input
    type="tel"
    className="form-control phone-number-input text-end"
    placeholder="ادخل رقم الجوال"
    value={phone}
    onChange={(e) => setPhone(e.target.value)}
  />
</div>
              {errors.phone && <small className="text-danger">{errors.phone}</small>}
            </div>
                        <div className="field">
       <div className="row ">

  {/* الدولة */}
  <div className="col-12 col-md-6 mb-2 text-end">
    <label className="mb-2 fw-semibold">الدولة</label>
    <input
      className="form-control"
      placeholder="الدولة"
      value={country}
      onChange={(e) => setCountry(e.target.value)}
    />
    {errors.country && (
      <small className="text-danger">{errors.country}</small>
    )}
  </div>
    {/* المدينة */}
  <div className="col-12 col-md-6 mb-3 text-end">
    <label className="mb-2 fw-semibold">المدينة/المحافظة</label>
    <input
      className="form-control"
      placeholder="المدينة/المحافظة"
      value={city}
      onChange={(e) => setCity(e.target.value)}
    />
    {errors.city && (
      <small className="text-danger">{errors.city}</small>
    )}
  </div>
</div>
<div className="field">
<div className=" text-end">
  <label className=" fw-semibold">العنوان</label>
  <input
    className="form-control"
    placeholder="العنوان"
    value={address}
    onChange={(e) => setAddress(e.target.value)}
  />
  {errors.address && (
    <small className="text-danger d-block text-end">
      {errors.address}
    </small>
  )}
</div>
</div>
</div>

            <div className="save-wrapper">
              <button type="submit" className="save-btn" disabled={loading}>
                {loading ? "جارٍ الحفظ..." : "حفظ"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <ToastContainer position="bottom-right" autoClose={2000} rtl theme="colored" />
    </>
  );
}
